module.exports = __webpack_public_path__ + "static/media/rede-protecao-1.f46236db.jpg";